const categoryRates = {
  1: 1.015,   // 1.5% زيادة
  2: 1.0175,  // 1.75% زيادة
  3: 1.020,   // 2.0% زيادة
  4: 1.0225,  // 2.25% زيادة
  5: 1.025,   // 2.5% زيادة
  6: 1.0275,  // 2.75% زيادة
  7: 1.030,   // 3.0% زيادة
  8: 1.0325,  // 3.25% زيادة
  9: 1.035,   // 3.5% زيادة
  10: 1.0375, // 3.75% زيادة
  11: 1.040   // 4.0% زيادة
};

export default categoryRates;
